import React, { useEffect, useState } from "react";
import { ModalBody, Button, Modal } from "reactstrap";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { compose } from "redux";
import axios from "axios";
import _ from "lodash";

import * as gameAction from "../../redux/game/action";
import * as loaderAction from "../../redux/loader/action";
import getTeamApiCall from "../../components/shared/utils/getTeamApiCall";

const InGameChangeTeam = ({
  magicLinkObj,
  current_user,
  setIsLoading,
  setCurrentUser,
  setMagicLinkData,
  disableForStrictMode,
  reset_magic_link_details,
  ...props
}) => {
  const user_id = _.get(current_user, "userId");
  const team_name = _.get(current_user, "team.description");
  const team_code = _.get(current_user, "team.id");

  const currentTime = new Date().getTime();
  const [openModal, setOpenModal] = useState(false);
  const [chooseDifferentTeamFlow, setChooseDifferentTeamFlow] = useState("");

  useEffect(() => {
    if (disableForStrictMode) {
      setOpenModal(true);
      setChooseDifferentTeamFlow("strictModeIsOn");
    } else if (
      !_.isEmpty(current_user) &&
      !_.isEmpty(magicLinkObj) &&
      sessionStorage.getItem("joinTeamFlow") === null
    ) {
      sessionStorage.setItem("joinTeamFlow", true);
      if (currentTime > magicLinkObj?.expiration_time) {
        setOpenModal(true);
        setChooseDifferentTeamFlow("linkExpired");
      } else {
        if (team_code === undefined) {
          join_team_api();
        } else {
          if (team_code === magicLinkObj?.team_code) {
            setOpenModal(true);
            setChooseDifferentTeamFlow("youHaveAlreadyJoinedThisTeam");
          } else {
            setOpenModal(true);
            if (current_user.userId === current_user.team.manager) {
              setChooseDifferentTeamFlow("youAreHost");
            } else {
              setChooseDifferentTeamFlow("selectDifferentTeam");
            }
          }
        }
      }
    }
  }, [
    team_code,
    currentTime,
    magicLinkObj,
    current_user,
    disableForStrictMode
  ]);

  const handleLinkExpiredBrowseLibrary = () => {
    setChooseDifferentTeamFlow("");
    setOpenModal(false);
    setIsLoading(false);
    props.history.push("/");
  };

  const join_team_api = async () => {
    let url = `${process.env.REACT_APP_CHECK_PROMOCODE}?userId=${user_id}&promocode=${magicLinkObj?.team_code}`;
    const res = await axios.get(url, {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": process.env.REACT_APP_API_KEY
      }
    });
    const res22 = await getTeamApiCall(magicLinkObj?.team_code);
    setCurrentUser({
      ...current_user,
      team: res22
    });
    setOpenModal(true);
    setChooseDifferentTeamFlow("youHaveJoinedTeam");
  };

  const handleChangeTeam = async () => {
    setOpenModal(false);
    setIsLoading(true);
    let url = `${process.env.REACT_APP_CHANGE_TEAM}`;
    const res = await axios.post(url, {
      from: team_code,
      to: magicLinkObj?.team_code,
      userId: user_id
    });
    const res22 = await getTeamApiCall(magicLinkObj?.team_code);
    setOpenModal(true);
    setChooseDifferentTeamFlow("youHaveJoinedTeam");
  };

  const handleContinue = () => {
    setOpenModal(false);
    reset_magic_link_details();
    sessionStorage.removeItem("joinTeamFlow");
  };

  return (
    <div className="in-change-modal">
      <Modal
        className="in-change-modal"
        centered
        isOpen={openModal && chooseDifferentTeamFlow !== ""}
      >
        {chooseDifferentTeamFlow === "strictModeIsOn" && (
          <ModalBody>
            <h2 className="title">
              Please change the privacy settings of your browser from Strict
              mode and Refresh the page.{" "}
            </h2>
          </ModalBody>
        )}

        {chooseDifferentTeamFlow === "youAreHost" && (
          <ModalBody>
            <h2 className="title">You can not join any other team</h2>
            <p className="info">
              Please note that as the current host of your team, you are not
              permitted to join any other teams at this time.
            </p>
            <div className="yes-no-btn">
              <Button onClick={handleContinue} className="cont-btn">
                continue
              </Button>
            </div>
          </ModalBody>
        )}

        {chooseDifferentTeamFlow === "linkExpired" && (
          <ModalBody>
            <h2 className="title">The invite link is expired</h2>
            <p className="info">
              The invite link you used is expired, please ask your manager for
              another invite link.They can create a new one by selecting Invite
              on the top bar at
            </p>
            <div className="team-login-link">
              <p className="login-directly">
                <span
                  onClick={() => {
                    window.location.href = "https://app.heylime.com";
                  }}
                >
                  https://app.heylime.com{" "}
                </span>{" "}
              </p>
            </div>
            <Button
              onClick={() => handleLinkExpiredBrowseLibrary()}
              className="browse-btn"
            >
              Browse Library
            </Button>
          </ModalBody>
        )}

        {chooseDifferentTeamFlow === "selectDifferentTeam" && (
          <ModalBody>
            <h2 className="title">You are already on a team </h2>
            <div className="team-flex">
              <h6 className="heading">Current Team:</h6>
              <p className="name">{team_name}</p>
            </div>
            <div className="team-flex">
              <h6 className="heading">New Team:</h6>
              <p className="name">{magicLinkObj?.team_name}</p>
            </div>
            <p className="info">
              Switching teams will remove you from your current team. Would you
              like to switch team accounts?
            </p>
            <div className="yes-no-btn">
              <Button
                onClick={() => setChooseDifferentTeamFlow("remainInTeam")}
                className="no"
              >
                No
              </Button>
              <Button onClick={handleChangeTeam} className="yes">
                Yes
              </Button>
            </div>
          </ModalBody>
        )}

        {chooseDifferentTeamFlow === "youHaveJoinedTeam" && (
          <ModalBody>
            <h2 className="title">you have joined a team!</h2>
            <div className="team-flex">
              <h6 className="heading">New Team: </h6>
              <p className="name">{magicLinkObj?.team_name}</p>
            </div>
            <div className="yes-no-btn">
              <Button onClick={handleContinue} className="cont-btn">
                continue
              </Button>
            </div>
          </ModalBody>
        )}
        {
          chooseDifferentTeamFlow === "youHaveAlreadyJoinedThisTeam" && (
            <ModalBody>
              <h2 className="title">You HAVE ALREADY JOINED THIS TEAM</h2>
              <div className="team-flex">
                <h6 className="heading">Current Team: </h6>
                <p className="name">{magicLinkObj?.team_name}</p>
              </div>
              <div className="team-login-link">
                <p className="login-directly">
                  You can login directly at{" "}
                  <span
                    onClick={() => {
                      window.location.href = "https://app.heylime.com";
                    }}
                  >
                    https://app.heylime.com{" "}
                  </span>{" "}
                </p>
              </div>
              <div className="yes-no-btn">
                <Button onClick={handleContinue} className="cont-btn">
                  continue
                </Button>
              </div>
            </ModalBody>
          )

          //   <ModalBody>
          //   <h2 className="title">Please change the browser privacy settings from strict mode </h2>
          //   {/* <div className="team-flex">
          //     <h6 className="heading">Current Team: </h6>
          //     <p className="name">{magicLinkObj?.team_name}</p>
          //   </div>
          //   <div className="team-login-link">
          //     <p className="login-directly">
          //       You can login directly at{" "}
          //       <span
          //         onClick={() => {
          //           window.location.href = "https://app.heylime.com";
          //         }}
          //       >
          //         https://app.heylime.com{" "}
          //       </span>{" "}
          //     </p>
          //   </div>
          //   <div className="yes-no-btn">
          //     <Button onClick={handleContinue} className="cont-btn">
          //       continue
          //     </Button>
          //   </div> */}
          // </ModalBody>
        }

        {chooseDifferentTeamFlow === "remainInTeam" && (
          <ModalBody>
            <h2 className="title">you will remain on your current Team </h2>
            <div className="team-flex">
              <h6 className="heading">Current Team: </h6>
              <p className="name">{team_name}</p>
            </div>
            <div className="yes-no-btn">
              <Button onClick={handleContinue} className="cont-btn">
                Continue
              </Button>
            </div>
          </ModalBody>
        )}
      </Modal>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    setIsLoading: (data) => dispatch(loaderAction.setIsLoading(data)),
    setMagicLinkData: (data) => dispatch(gameAction.setMagicLinkData(data))
  };
};

export default compose(
  withRouter,
  connect(null, mapDispatchToProps)
)(InGameChangeTeam);
